<template>
  <div class="wrap mt-5">
    <div v-if="timeMsg == ''" class="d-flex flex-column align-items-center cards">
      <div class="row inputWrap">
        <div class="col-12">
          <h4 class="ml-1  text-center">充值金額：NT${{Math.round(order.real_price)}}</h4>
          <h5 class="ml-1  text-center">剩餘時間： <span class="text-danger">{{time}}</span></h5>
          <h5 class="ml-1  text-center">請轉入 <span class="text-danger">{{order.display_price}}</span> USDT</h5>
          <img class="mt-3 mb-1 qrCode" :src="order.qr_url" alt />
        </div>
        <div class="col-12">
          <h6 class=" text-center">充值地址</h6>
          <p class=" text-center w-100">
            {{order.bank_no}}
          </p>
          <div class="d-flex justify-content-center">
          <button v-clipboard:copy="order.bank_no" 
              v-clipboard:success="onCopy" class="btn btn-green">複製</button>
          </div>
        </div>
      </div>
      <div class="w-100">
        <p class="mb-0 mt-3 text-left">注意:</p>
        <p class="text-left">1.請勿使用上述地址支付任何ERC20 USDT資產，否則資產將無法找回。</p>
        <!-- <p class="text-left">2.當前Okex/火幣／幣安交易所 USDT 最新廠外賣出單價。 <span class="text-danger h5">{{order.rate}}</span>元。</p> -->
        <p class="text-left">2.請確保收款地址收到 <span class="text-danger h5">{{order.display_price}}</span> USDT <span class="text-danger h5">「不含轉帳手續費」</span>，否則無法到帳。</p>
        <p class="text-left">3.您支付至上述地址後，需要整個網絡節點的確認，請耐心等待。</p>
      </div>
    </div>
    <div v-else>
      <h4 class="tit1">{{timeMsg}}</h4>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      order: "",
      timeout: "",
      timeMsg: "",
      time:'',
      endTime:''
    };
  },
  computed: {},
  methods: {
    onCopy(){
      this.$message.success('复制成功')
    },
    getOrder() {
      axios
        .get(
          `${process.env.VUE_APP_DEFAULT_SRC}/aaa/query?transaction_id=${this.$route.query.transaction_id}`
        )
        .then(res => {
          if (res.data.code == 0) {
            this.order = res.data.data;
            this.endTime = res.data.data.expired
            this.timeOut()
          } else {
            this.timeMsg = res.data.message;
            clearInterval(this.timeout);
          }
        });
    },
    timeOut(){
    let ths = this
    let endTime = new Date(this.endTime.replace(/-/g, "/"));
    function checktime(){
      if(endTime.getTime() < new Date().getTime()){
        clearInterval(close)
        ths.timeMsg = '訂單逾期失效'
      }
        let now = new Date(),
            diff = new Date(endTime - now);
        ths.time = diff.Myformat();
    }

    Date.prototype.Myformat = function(){
        return ("0"+ this.getUTCHours()).slice(-2)+":"+("0"+this.getUTCMinutes()).slice(-2)+":"+("0"+this.getUTCSeconds()).slice(-2)
    }

    let close = setInterval(checktime, 1000);
    }
  },
  created() {
    this.getOrder();
  }
};
</script>
<style lang="scss">
body {
  background-color: #EBEFF0 !important;
}
.wrap {
  padding: 25px;
  width: 95%;
  margin-left: 2.5%;
  min-height: 90vh;
  border-radius: 10px;
  align-items: center;
  display: flex;
  justify-content: center;
}
p {
  color:black;
  word-break:break-all;
}
.cards {
  box-shadow: 1;
  background-color: #fff;
  display: block;
  padding: 50px;
  border-radius: 10px;
  -webkit-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
  -moz-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
  box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
}
@media(max-width:768px) {
  .cards {
    padding: 20px
  }
}
</style>